import React, { useContext, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { SnackbarContext } from "./Snackbar";
import { LoadingContext } from "./Loading";
import ErrorFullScreenMessage from "../components/fullScreenMessage/ErrorFullScreenMessage";
import { ERROR } from "../enums/AlertTypes";
import useUser, { useGetUserId } from "../hooks/useUser";
import { snackbarSeverity } from "../hooks/useSnackbar";
import api from "../utils/api/authApi";

export const UserContext = React.createContext();

//TODO: what the hell is this???
export const fetchUsers = async ({ queryKey }) => {
  const [, { userId, currentClinicId, isMaster }] = queryKey;

  let url = "";

  if (isMaster) {
    url = `/users?id=${userId}`;
  } else {
    url = currentClinicId
      ? `/clinic/users/${currentClinicId}`
      : `/users?id=${userId}`;
  }

  const response = await api.get(url);
  return response.data;
};

export default function UserProvider({ children }) {
  const { currentClinic, roles } = useUser();
  const userId = useGetUserId();
  const { handleSnackbar } = useContext(SnackbarContext);

  const {
    data: users = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: [
      "users",
      {
        userId,
        currentClinicId: currentClinic?.id,
        isMaster: roles?.master,
      },
    ],
    queryFn: fetchUsers,
    enabled: !!userId && (!!roles?.master || !!currentClinic?.id),
    onError: (err) => {
      if (err.response) {
        handleSnackbar(err?.response?.data, snackbarSeverity.ERROR);
      } else if (err.request) {
        handleSnackbar("Network Error: No response from the server.", ERROR);
      } else {
        handleSnackbar(
          "Network Error: Failed to establish connection with the server.",
          ERROR
        );
      }
    },
  });

  const values = useMemo(
    () => ({
      getUserById: (id) => users.find((user) => user.id === id),
      getAutoCompleteUsers: () => users.filter((user) => user.role === "USER"),
      getUsers: () => users,
      isLoading,
      error,
    }),
    [users]
  );

  return <UserContext.Provider value={values}>{children}</UserContext.Provider>;
}
